import * as React from 'react';
import { SCLoanDetailPage } from "./css";
import Footer from '../Footer';
import { PlanStatus } from "@payright/web-components";

export interface LoanDetailPageProps {
  /** loan dashboard data */
  loanDetailPageData: {
      status: string;
      loanAmount: number;
      estalishmentFees: number;
      remainingBalance: number;
      loanTerm: number;
      repaymentFrequency: number;
      estFinalRepaymentDate: string;
      balanceRemaining: number;
      storeName: string;
      interestRate: number;
      loanPurpose: string;
      accountKeepingFee: number;
  };
}

const LoanDetailPage = ({
  loanDetailPageData
}: LoanDetailPageProps) => (
      <SCLoanDetailPage>
          <div className="parent">
              <div className="column">
                  <div className="row">
                      <label>Status</label>
                      <span className="status"><PlanStatus status={loanDetailPageData.status} /></span>
                  </div>
                  <div className="row">
                      <label>Loan Amount</label>
                      <span>${loanDetailPageData.loanAmount}</span>
                  </div>
                  <div className="row">
                      <label>Origination Fee</label>
                      <span>${loanDetailPageData.estalishmentFees}</span>
                  </div>
                  <div className="row">
                      <label>Merchant store</label>
                      <span>{loanDetailPageData.storeName}</span>
                  </div>
                  <div className="row">
                      <label>Repayment Frequency</label>
                      <span>{loanDetailPageData.repaymentFrequency}</span>
                  </div>
                  <div className="row">
                      <label>Loan Term (months)</label>
                      <span>{loanDetailPageData.loanTerm}</span>
                  </div>
              </div>
              <div className="column">
                  <div className="row">
                      <label>Interest rate</label>
                      <span>{loanDetailPageData.interestRate}%</span>
                  </div>
                  <div className="row">
                      <label>Estimated Final Repayment Date</label>
                      <span>{loanDetailPageData?.estFinalRepaymentDate}</span>
                  </div>
                
                  <div className="row">
                      <label>Loan purpose</label>
                      <span>{loanDetailPageData.loanPurpose}</span>
                  </div>
                  <div className="row">
                      <label>Loan Management Fee per Repayment</label>
                      <span>${loanDetailPageData.accountKeepingFee}</span>
                  </div>
              </div>
          </div>

      <Footer />
  </SCLoanDetailPage>
);

export default LoanDetailPage;
